export default {
    keyfobs_main_title: 'Llaveros',
    keyfobs_main_add_driver_key: 'Agregar etiqueta del conductor',
    keyfobs_main_model: 'Modelo',
    keyfobs_main_account: 'Cuenta',
    keyfobs_main_keyfob_model: 'Modelo del Llavero',
    keyfobs_main_move: 'Mover a otra cuenta',
    keyfobs_main_unassign: 'Desasignar conductores',
};